module.exports = __webpack_public_path__ + "img/fail-bg.57077b37.svg";